/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AssessmentSummaryItem } from './AssessmentSummaryItem';
import {
    AssessmentSummaryItemFromJSON,
    AssessmentSummaryItemFromJSONTyped,
    AssessmentSummaryItemToJSON,
    AssessmentSummaryItemToJSONTyped,
} from './AssessmentSummaryItem';

/**
 * 
 * @export
 * @interface AssessmentSummaryResponse
 */
export interface AssessmentSummaryResponse {
    /**
     * 
     * @type {Array<AssessmentSummaryItem>}
     * @memberof AssessmentSummaryResponse
     */
    items?: Array<AssessmentSummaryItem>;
}

/**
 * Check if a given object implements the AssessmentSummaryResponse interface.
 */
export function instanceOfAssessmentSummaryResponse(value: object): value is AssessmentSummaryResponse {
    return true;
}

export function AssessmentSummaryResponseFromJSON(json: any): AssessmentSummaryResponse {
    return AssessmentSummaryResponseFromJSONTyped(json, false);
}

export function AssessmentSummaryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssessmentSummaryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(AssessmentSummaryItemFromJSON)),
    };
}

export function AssessmentSummaryResponseToJSON(json: any): AssessmentSummaryResponse {
    return AssessmentSummaryResponseToJSONTyped(json, false);
}

export function AssessmentSummaryResponseToJSONTyped(value?: AssessmentSummaryResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(AssessmentSummaryItemToJSON)),
    };
}

